/**
 * Local chat cache storage.
 */
const STORAGE = window.localStorage
const menuVisibility = 'menuVisibility'
const smsFilters = 'smsFilters'
const smsSortProperty = 'smsSortProperty'
const smsSortDirection = 'smsSortDirection'
const smsFilterClosed = 'smsFilterClosed'
const smsFilterRead = 'smsFilterRead'
const dmFilters = 'dmFilters'
const dmSortProperty = 'dmSortProperty'
const dmSortDirection = 'dmSortDirection'
const dmFilterClosed = 'dmFilterClosed'
const dmFilterRead = 'dmFilterRead'
const channelsFilters = 'channelsFilters'
const channelsSortProperty = 'channelsSortProperty'
const channelsSortDirection = 'channelsSortDirection'
const channelsFilterClosed = 'channelsFilterClosed'
const channelsFilterRead = 'channelsFilterRead'
const groupsFilters = 'groupsFilters'
const groupsSortProperty = 'groupsSortProperty'
const groupsSortDirection = 'groupsSortDirection'
const groupsFilterClosed = 'groupsFilterClosed'
const groupsFilterRead = 'groupsFilterRead'

export default {

  clear () {
    STORAGE.clear()
  },

  /*
    GETTERS
    */
  menuVisibility () {
    const ls = STORAGE.getItem(menuVisibility)
    if (ls) {
      return JSON.parse(ls)
    }
    return null
  },

  /*
  * SMS
  */
  smsFilters () {
    const ls = STORAGE.getItem(smsFilters)
    if (ls) {
      return JSON.parse(ls)
    }
    return null
  },

  smsSortProperty () {
    return STORAGE.getItem(smsSortProperty)
  },

  smsSortDirection () {
    return STORAGE.getItem(smsSortDirection)
  },

  smsFilterClosed () {
    return STORAGE.getItem(smsFilterClosed) === 'true'
  },

  smsFilterRead () {
    return STORAGE.getItem(smsFilterRead) === 'true'
  },

  /*
  * DM
  */
  dmFilters () {
    const ls = STORAGE.getItem(dmFilters)
    if (ls) {
      return JSON.parse(ls)
    }
    return null
  },

  dmSortProperty () {
    return STORAGE.getItem(dmSortProperty)
  },

  dmSortDirection () {
    return STORAGE.getItem(dmSortDirection)
  },

  dmFilterClosed () {
    return STORAGE.getItem(dmFilterClosed) === 'true'
  },

  dmFilterRead () {
    return STORAGE.getItem(dmFilterRead) === 'true'
  },

  /*
  * CHANNELS
  */
  channelsFilters () {
    const ls = STORAGE.getItem(channelsFilters)
    if (ls) {
      return JSON.parse(ls)
    }
    return null
  },

  channelsSortProperty () {
    return STORAGE.getItem(channelsSortProperty)
  },

  channelsSortDirection () {
    return STORAGE.getItem(channelsSortDirection)
  },

  channelsFilterClosed () {
    return STORAGE.getItem(channelsFilterClosed) === 'true'
  },

  channelsFilterRead () {
    return STORAGE.getItem(channelsFilterRead) === 'true'
  },

  /*
  * GROUPS
  */
  groupsFilters () {
    const ls = STORAGE.getItem(groupsFilters)
    if (ls) {
      return JSON.parse(ls)
    }
    return null
  },

  groupsSortProperty () {
    return STORAGE.getItem(groupsSortProperty)
  },

  groupsSortDirection () {
    return STORAGE.getItem(groupsSortDirection)
  },

  groupsFilterClosed () {
    return STORAGE.getItem(groupsFilterClosed) === 'true'
  },

  groupsFilterRead () {
    return STORAGE.getItem(groupsFilterRead) === 'true'
  },

  /*
   SETTERS
  */
  setMenuVisibility (value) {
    return STORAGE.setItem(menuVisibility, JSON.stringify(value))
  },

  /*
  * SMS
  */
  // filter by pn
  setSmsFilters (value) {
    return STORAGE.setItem(smsFilters, JSON.stringify(value))
  },

  setSmsSortProperty (value) {
    return STORAGE.setItem(smsSortProperty, value)
  },

  setSmsSortDirection (value) {
    return STORAGE.setItem(smsSortDirection, value)
  },

  setSmsFilterClosed (value) {
    return STORAGE.setItem(smsFilterClosed, JSON.stringify(value))
  },

  setSmsFilterRead (value) {
    return STORAGE.setItem(smsFilterRead, JSON.stringify(value))
  },

  /*
  * DM
  */
  setDmFilters (value) {
    return STORAGE.setItem(dmFilters, JSON.stringify(value))
  },

  setDmSortProperty (value) {
    return STORAGE.setItem(dmSortProperty, value)
  },

  setDmSortDirection (value) {
    return STORAGE.setItem(dmSortDirection, value)
  },

  setDmFilterClosed (value) {
    return STORAGE.setItem(dmFilterClosed, JSON.stringify(value))
  },

  setDmFilterRead (value) {
    return STORAGE.setItem(dmFilterRead, JSON.stringify(value))
  },

  /*
  * CHANNELS
  */
  setChannelsFilters (value) {
    return STORAGE.setItem(channelsFilters, JSON.stringify(value))
  },

  setChannelsSortProperty (value) {
    return STORAGE.setItem(channelsSortProperty, value)
  },

  setChannelsSortDirection (value) {
    return STORAGE.setItem(channelsSortDirection, value)
  },

  setChannelsFilterClosed (value) {
    return STORAGE.setItem(channelsFilterClosed, JSON.stringify(value))
  },

  setChannelsFilterRead (value) {
    return STORAGE.setItem(channelsFilterRead, JSON.stringify(value))
  },

  /*
  * GROUPS
  */
  setGroupsFilters (value) {
    return STORAGE.setItem(groupsFilters, JSON.stringify(value))
  },

  setGroupsSortProperty (value) {
    return STORAGE.setItem(groupsSortProperty, value)
  },

  setGroupsSortDirection (value) {
    return STORAGE.setItem(groupsSortDirection, value)
  },

  setGroupsFilterClosed (value) {
    return STORAGE.setItem(groupsFilterClosed, JSON.stringify(value))
  },

  setGroupsFilterRead (value) {
    return STORAGE.setItem(groupsFilterRead, JSON.stringify(value))
  }
}
